import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=3ae7ad32&"
import script from "./ProductModal.vue?vue&type=script&lang=js&"
export * from "./ProductModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\redeem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae7ad32')) {
      api.createRecord('3ae7ad32', component.options)
    } else {
      api.reload('3ae7ad32', component.options)
    }
    module.hot.accept("./ProductModal.vue?vue&type=template&id=3ae7ad32&", function () {
      api.rerender('3ae7ad32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Redeem/components/ProductModal.vue"
export default component.exports